jQuery(document).ready(function() {


setTimeout(function() {
            var sort_by = getUrlParameter('sort_by');
            console.log(sort_by);

            setTimeout(function() {
                if(sort_by === 'discount_percentage'){
                    var $ul = $('.js-grid');

                    var sortedLis = $ul.children('div').sort(function(a, b) {
                        var discountA = parseFloat($(a).attr('data-discount'));
                        var discountB = parseFloat($(b).attr('data-discount'));
                        return discountB - discountA; // Descending order
                    });

                    $ul.append(sortedLis);
                }
            }, 1500);

        }, 2500);

console.log("Hello Developer is here");
    // var discountSortParam = "{{ sort_by | escape }}";
    
    var getUrlParameter = function(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    jQuery(document).on('click', '.popout-list .popout-list__item, .pagination-custom .pagination-custom__num, .pagination-custom .pagination-custom__arr', function() {
        setTimeout(function() {
            var sort_by = getUrlParameter('sort_by');
            console.log(sort_by);

            setTimeout(function() {
                if(sort_by === 'discount_percentage'){
                    var $ul = $('.js-grid');

                    var sortedLis = $ul.children('div').sort(function(a, b) {
                        var discountA = parseFloat($(a).attr('data-discount'));
                        var discountB = parseFloat($(b).attr('data-discount'));
                        return discountB - discountA; // Descending order
                    });

                    $ul.append(sortedLis);
                }
            }, 1500);

        }, 2500);
    });


});


// <script src="https://code.jquery.com/jquery-3.6.0.min.js"></script>

  $(document).ready(function() {
    // Check if the URL parameter 'sort_by' is 'discount_percentage'
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('sort_by') === 'discount_percentage') {
      // Select the container with the products
      var $productGrid = $('.js-grid');

      if ($productGrid.length) {
        // Get all product items
        var $productItems = $productGrid.find('.product-item').toArray();

        // Sort product items by the 'data-discount' attribute
        $productItems.sort(function(a, b) {
          var discountA = parseFloat($(a).data('discount'));
          var discountB = parseFloat($(b).data('discount'));
          return discountB - discountA; // Sort in descending order
        });

        // Clear the product grid
        $productGrid.empty();

        // Append sorted product items back to the product grid
        $.each($productItems, function(index, item) {
          $productGrid.append(item);
        });
      }
    }
  });
/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
